import infoStyles from "../../styles/estilos/infoMetodos.module.css";
import transferInfoImage from "../../images/info_transferencia_bancaria.png";

function TransferInfo() {
  return (
    <div className={infoStyles.infoContainer}>
      <img
        src={transferInfoImage}
        alt="Información de transferencia bancaria"
        className={infoStyles.transferInfoImage}
      />
    </div>
  );
}

export default TransferInfo;
